// @ts-nocheck
import Zone from "@insite/client-framework/Components/Zone";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { getSession } from "@insite/client-framework/Store/Context/ContextSelectors";
import { getCurrentPage } from "@insite/client-framework/Store/Data/Pages/PageSelectors";
import translate from "@insite/client-framework/Translate";
import WidgetModule from "@insite/client-framework/Types/WidgetModule";
import WidgetProps from "@insite/client-framework/Types/WidgetProps";
import OrderHeader from "@store/Library/Components/Toolkit/Order/OrderHeader";
import constants from "@store/constants";
import React, { FC } from "react";
import { connect } from "react-redux";

const mapStateToProps = (state: ApplicationState) => ({
    isSettingNewPassword: state.greif.pages.resetPassword.isSettingNewPassword,
    pageTitle: getCurrentPage(state).fields.title,
    session: getSession(state),
});

type Props = WidgetProps & ReturnType<typeof mapStateToProps>;

export interface ResetPasswordHeaderStyles {}

export const resetPasswordHeaderStyles: ResetPasswordHeaderStyles = {};

const styles = resetPasswordHeaderStyles;

const ResetPasswordHeader: FC<Props> = ({ id, pageTitle, isSettingNewPassword, session }: Props) => {
    const pageTitleLabel = isSettingNewPassword
        ? translate(session.activateAccount ? "Set Password" : "Welcome to Greif+")
        : pageTitle;

    return (
        <OrderHeader title={pageTitleLabel}>
            <Zone contentId={id} zoneName="ActionButtons" />
        </OrderHeader>
    );
};

const widgetModule: WidgetModule = {
    component: connect(mapStateToProps)(ResetPasswordHeader),
    definition: {
        group: constants.widgetGroup.resetPassword,
        displayName: "Header",
        allowedContexts: [constants.pageType.resetPassword],
    },
};

export default widgetModule;
